import React from 'react';
import { TableRow, TableCell, Chip, Typography } from '@mui/material';
import { CheckCircle, Cancel, Error as ErrorIcon } from '@mui/icons-material';

/**
 * 单个提交记录项组件
 */
function SubmissionItem({ submission, isLatest = false }) {
  const getStatusColor = (status) => {
    switch (status) {
      case 'passed': return 'success';
      case 'failed': return 'error';
      case 'error': return 'warning';
      default: return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'passed': return <CheckCircle fontSize="small" />;
      case 'failed': return <Cancel fontSize="small" />;
      case 'error': return <ErrorIcon fontSize="small" />;
      default: return null;
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <TableRow
      hover
      sx={{
        bgcolor: isLatest ? 'action.hover' : 'inherit',
        borderLeft: isLatest ? '3px solid' : 'none',
        borderLeftColor:
          submission.status === 'passed'
            ? 'success.main'
            : submission.status === 'failed'
            ? 'error.main'
            : 'warning.main'
      }}
    >
      <TableCell>
        <Chip
          label={submission.status === 'passed' ? 'Accepted' : 'Wrong Answer'}
          color={getStatusColor(submission.status)}
          size="small"
          icon={getStatusIcon(submission.status)}
        />
      </TableCell>
      <TableCell align="center">
        <Typography
          variant="body2"
          fontWeight="bold"
          color={submission.status === 'passed' ? 'success.main' : 'text.primary'}
        >
          {submission.score}
        </Typography>
      </TableCell>
      <TableCell align="center">
        {submission.testResults && typeof submission.testResults === 'object' ? (
          <Typography variant="body2">
            {submission.testResults.passed}/{submission.testResults.attempted}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary">
            -
          </Typography>
        )}
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {formatDate(submission.submittedAt)}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default SubmissionItem;

